import classNames from 'classnames';
import { MachineTranslationMixin } from './machine_translation_mixin';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';
import * as styles from './translationEditInterface.module.scss';

const createReactClass = require('create-react-class');

const TranslationEditInterface = createReactClass({
  getInitialState() {
    const sourceTranslation = this.props.translations.filter(function(translation) {
      return translation.is_source;
    })[0];
    const sortedTranslations = this.sortTranslations(this.props.translations);
    return {
      translations: sortedTranslations,
      selectedTable: this.props.table,
      selectedColumnName: this.props.columnName,
      selectedRowId: this.props.rowId,
      sourceTranslation,
      saveInProgress: false,
      showNewTranslationForm: false,
      originalSlug: this.props.originalSlug,
      sourceEntry: this.props.sourceEntry
    };
  },
  languageRegionCodeToLanguageName(languageRegionCode) {
    // languageRegionCode might not exist in acceptedLanguages; eg we may have an old one labeled as 'no' but we
    // now use 'nb-NO'.  This works ok -- it is shown without a language label, and can be fixed by the admin.
    return this.props.acceptedLanguages[languageRegionCode]?.name;
  },
  sortTranslations(translations) {
    const sortedTranslations = translations.sort((a, b) => {
      return this.languageRegionCodeToLanguageName(a.language) > this.languageRegionCodeToLanguageName(b.language) ? 1 : -1;
    });

    return this.appendBlankLanguagesToTranslationsList(sortedTranslations);
  },
  findLocalizationFromInputs() {
    const newTableName = this.refs.table.value;
    const newColumnName = this.refs.column.value;
    const newRowId = this.refs.rowId.value;
    // only search if localization will be different
    if (newTableName == this.state.selectedTable && newColumnName == this.state.selectedColumnName && newRowId == this.state.selectedRowId) {
      return;
    }
    const url = LanguageSupportUtil.wrapUrlSafe(`/edit-translations?table=${newTableName}&column_name=${newColumnName}&id=${newRowId}`);
    window.history.pushState(null, '', url);
    window.history.go();
  },
  appendBlankLanguagesToTranslationsList(sortedTranslations) {
    // create blank boxes for languages that we usually have but do not exist for this localization set
    const missingLanguageEntries = this.props.enabledLanguages;
    for (let i = 0; i < sortedTranslations.length; i++) {
      const index = missingLanguageEntries.indexOf(sortedTranslations[i].language);
      if (index > -1) {
        missingLanguageEntries.splice(index, 1);
      }
    }
    const blankBoxLanguages = missingLanguageEntries.map(i => {
      return { language: i };
    });
    sortedTranslations = sortedTranslations.concat(blankBoxLanguages);
    return sortedTranslations;
  },
  validate() {
    const source = this.state.translations.find(t => t.is_source);
    const hasTranslations = this.state.translations.find(t => t.content?.trim());
    if (!source && hasTranslations) {
      alert('You must select a source string if there are any translations');
      return false;
    } else if ((source && !source.content?.trim()) && hasTranslations) {
      alert(`Please enter a translation string for ${this.props.acceptedLanguages[source.language].name}`);
      return false;
    }
    return true;
  },
  validateNameColumn() {
    const source = this.state.translations.find(t => t.is_source);
    if (!source) {
      alert('Name columns must have a source string');
      return false;
    } else if (!source.content?.trim()) {
      alert(`Please enter a translation string for ${this.props.acceptedLanguages[source.language].name}`);
      return false;
    }
    return true;
  },
  performSaveAll(retranslateOption) {
    const isNameColumn = this.state.selectedColumnName === 'name';
    const isValid = isNameColumn ? this.validateNameColumn() : this.validate();
    if (!isValid) return

    // save new one if we have one
    if (this.state.showNewTranslationForm) {
      this.handleCreateNewLocalizationClick();
    }

    const updateBody = {
      translations: this.state.translations,
      retranslate: retranslateOption,
      rowId: this.state.selectedRowId,
      table: this.state.selectedTable,
      columnName: this.state.selectedColumnName
    };
    this.setState({ saveInProgress: true });
    ServerCommunicationUtil.putApiEndpoint(
      '/api/alltrails/localizations/1',
      updateBody,
      data => {
        const currUrl = `/edit-translations?table=${this.state.selectedTable}&column_name=${this.state.selectedColumnName}&id=${this.state.selectedRowId}`;
        if (currUrl === window.location.href) {
          window.location.reload();
        } else {
          window.location.href = currUrl;
        }
      },
      err => {
        console.error('Error occurred', err);
      },
      data => {
        this.setState({ saveInProgress: false });
      }
    );
  },
  handleSaveClick() {
    this.performSaveAll(false);
  },
  handleSaveAndReTransClick() {
    this.performSaveAll(true);
  },
  handleToggleCreateRowClick(e) {
    this.setState({ showNewTranslationForm: !this.state.showNewTranslationForm });
  },
  handleClearTranslationsClick() {
    // sending an empty translation string will result in a deleted translation
    const translations = this.state.translations.map(t => (t.content && !t.is_source ? { ...t, content: ''} : { ...t }));
    this.setState({ translations })
  },
  handleChangeSource(index, e) {
    if (this.state.translations[index].is_source) {
      return;
    }
    const currentTranslations = this.state.translations;
    let newSourceTranslation;
    for (let i = 0; i < currentTranslations.length; i++) {
      if (i == index) {
        currentTranslations[i].is_source = true;
        newSourceTranslation = currentTranslations[i];
      } else {
        currentTranslations[i].is_source = false;
      }
    }
    this.setState({ translations: currentTranslations, sourceTranslation: newSourceTranslation });
  },
  handleTextAreaKeyUp(index, e) {
    // maintain any changes, consider a translation to be done by a human if they explicitly entered text
    const translations = [...this.state.translations];
    translations[index].content = e.target.value;
    translations[index].translated_by = 'HU';
    this.setState({ translations });
  },
  handleLanguageSelectChange(index, e) {
    const translations = [...this.state.translations];
    translations[index].language = e.target.value;
    translations[index].translated_by = 'HU';
    this.setState({ translations });
  },
  handleDeleteClick(i, targetLanguage) {
    const isSource = this.state.translations[i].is_source;
    const hasTranslations = this.state.translations.find(t => t.content?.trim() && !t.is_source)
    const isNameColumn = this.state.selectedColumnName === 'name';

    if (isNameColumn && isSource) {
      const msg = "The source string of this object cannot be deleted. Please assign an alternate language as the source string before deleting this translation.";
      alert(msg);
      return false;
    }
    if (isSource && hasTranslations) {
      const msg = "The source string of this object can only be deleted if there are no translations. Please clear all translations or assign an alternate language as the source string before deleting.";
      alert(msg);
      return false;
    }
    const localizationId = this.state.translations[i].id;
    ServerCommunicationUtil.deleteApiEndpoint(
      `/api/alltrails/localizations/${localizationId}`,
      {},
      data => {
        let translations = this.state.translations.filter((translation, idx) => {
          return translation.id !== localizationId;
        });
        translations = this.sortTranslations(translations);
        this.setState({ translations });
      },
      () => {},
      () => {}
    );
  },
  changeTableSelection(e) {
    this.setState({ selectedTable: e.target.value });
  },
  handleRetranslateClick(i, targetLanguage) {
    // TOOLS-544 We can only pass 2-char codes to V2 Google Translate, and it will return an error if we try
    // to translate from say "pt-PT" to "pt-BR".  For now block such an attempt, pending future upgrade to V3.
    if (MachineTranslationMixin.localeCodetoISO(targetLanguage) === MachineTranslationMixin.localeCodetoISO(this.state.sourceTranslation.language)) {
      alert(`We cannot currently translate from ${this.state.sourceTranslation.language} to ${targetLanguage}.`);
      return;
    }
    const targetText = this.refs[`content-${this.state.sourceTranslation.language}`].value;
    // need to change state and force text areas to pick up new content
    MachineTranslationMixin.translateString(
      targetText,
      targetLanguage,
      MachineTranslationMixin,
      function(translatedString) {
        const currentTranslations = this.state.translations;
        const changedTranslation = currentTranslations[i];
        changedTranslation.content = translatedString;
        changedTranslation.translated_by = 'GT';
        this.setState({ translations: currentTranslations });
      }.bind(this),
      this.state.sourceTranslation.language
    );
  },
  saveNewLocalization(targetLang, targetText) {
    const newTranslationBody = {
      code: targetLang,
      content: targetText.trim(),
      rowId: this.state.selectedRowId,
      table: this.state.selectedTable,
      columnName: this.state.selectedColumnName
    };

    this.setState({ saveInProgress: true });
    ServerCommunicationUtil.postApiEndpoint(
      '/api/alltrails/localizations',
      { new_translation: newTranslationBody },
      localizations => {
        if (localizations) {
          const currentTranslations = this.state.translations;
          currentTranslations.push(localizations[0]);
          this.setState({ translations: currentTranslations, showNewTranslationForm: false });
        }
      },
      err => {
        console.error('Error occurred', err);
        const resp = JSON.parse(err.responseText);
        if (resp && resp.errors && resp.errors[0].code == 'invalid_param') {
          alert(`Translation already exists for ${this.props.acceptedLanguages[targetLang].name}`);
        }
      },
      data => {
        this.setState({ saveInProgress: false });
      }
    );
  },
  handleCreateNewLocalizationClick() {
    let targetText = this.refs['new-translation-content'].value;
    const targetLang = this.refs['new-translation-langcode'].value;
    let translatePromise = null;

    if (this.state.sourceTranslation && (targetText == '' || targetLang == '')) {
      if (confirm('Missing text for new translation.  Do you want to generate one from the source language?')) {
        const targetTextForNewTranslation = this.refs[`content-${this.state.sourceTranslation.language}`].value;
        const transFunc = MachineTranslationMixin.translateString;
        translatePromise = new Promise(function(resolve, reject) {
          transFunc(targetTextForNewTranslation, targetLang, MachineTranslationMixin, function(translatedString) {
            targetText = translatedString;
            resolve(translatedString);
          });
        });
      }
    }
    if (translatePromise != null) {
      translatePromise.then(
        function(str) {
          this.saveNewLocalization(targetLang, targetText);
        }.bind(this)
      );
    } else {
      this.saveNewLocalization(targetLang, targetText);
    }
  },
  renderSearchSelections() {
    const tableToColumnHash = {
      trails: ['name', 'description', 'tips', 'getting_there', 'parking_facilities', 'contact_info'],
      areas: ['name', 'overview', 'description'],
      lists: ['title', 'description'],
      states: ['name', 'overview', 'description'],
      cities: ['name', 'overview', 'description'],
      countries: ['name', 'overview', 'description'],
      at_map_markers: ['name', 'description'],
      at_maps: ['name', 'description'],
      trail_reviews: ['comment'],
      at_attributes: ['name'],
      users: ['about_me'],
      banners: ['message']
    };

    let columnOpts = [];
    if (this.state.selectedTable) {
      columnOpts = tableToColumnHash[this.state.selectedTable].map((item, index) => {
        return (
          <option key={this.state.selectedTable + index} value={item}>
            {item}
          </option>
        );
      });
    }

    let tableOptions = [
      <option key="notable" value={-1}>
        - Select a table -
      </option>
    ];
    tableOptions = tableOptions.concat(
      Object.keys(tableToColumnHash).map((item, index) => {
        return (
          <option key={item + index} value={item}>
            {item}
          </option>
        );
      })
    );

    return (
      <div className="localization-search-bar">
        <select ref="table" defaultValue={this.state.selectedTable} onChange={this.changeTableSelection}>
          {tableOptions}
        </select>
        <select ref="column" defaultValue={this.state.selectedColumnName}>
          {columnOpts}
        </select>
        <input ref="rowId" defaultValue={this.state.selectedRowId} />
        <span className="btn btn-slim blue rounded form-top" onClick={this.findLocalizationFromInputs}>
          Find
        </span>
      </div>
    );
  },
  translatedByHash: {
    GT: 'Google MT',
    DL: 'DeepL',
    HU: 'Human',
    SL: 'Smartling',
    MB: 'Mapbox',
    CL: 'CLD'
  },
  renderTableOrg(sortedTranslations) {
    return (
      <table className="lifeline-history">
        <thead>
          <tr>
            <th>Language</th>
            <th>Source</th>
            <th>Translated By</th>
            <th>Content</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedTranslations.map(this.renderTranslationTableRow)}
          {this.state.showNewTranslationForm && this.renderNewTranslationForm()}
        </tbody>
      </table>
    );
  },
  renderButtonContainer() {
    if (this.state.translations.length > 0) {
      return (
        <div className={classNames('user-info-centered', styles.buttonContainer)}>
          <div className="btn green rounded simple" onClick={this.handleSaveClick}>
            {this.state.saveInProgress ? 'Saving...' : 'Save'}
          </div>
          <div className="btn blue rounded simple" onClick={this.handleSaveAndReTransClick}>
            {this.state.saveInProgress ? 'Saving...' : 'Save and Retranslate All'}
          </div>
          <div className="btn orange rounded simple" onClick={this.handleToggleCreateRowClick}>
            {this.state.showNewTranslationForm ? 'Cancel' : 'Create New Translation'}
          </div>
          <div className="btn red rounded simple" onClick={this.handleClearTranslationsClick}>
            Clear All Translations
          </div>
        </div>
      );
    }
    return (
      <div className={classNames('user-info-centered', styles.buttonContainer)}>
        <div className="btn orange rounded simple" onClick={this.handleToggleCreateRowClick}>
          {this.state.showNewTranslationForm ? 'Cancel' : 'Create New Translation'}
        </div>
      </div>
    );
  },
  generateOptions() {
    return Object.keys(this.props.acceptedLanguages).map(key => (
      <option key={key} value={key}>
        {this.props.acceptedLanguages[key].name}
      </option>
    ));
  },
  renderNewTranslationForm() {
    const languageOptions = [<option value="-1">- Choose Language -</option>, ...this.generateOptions()];

    return (
      <tr>
        <td>
          <select ref="new-translation-langcode">{languageOptions}</select>
        </td>
        <td />
        <td />
        <td>
          <textarea ref="new-translation-content" defaultValue="" />
        </td>
        <td>
          <span className="btn btn-slim blue rounded" onClick={this.handleCreateNewLocalizationClick}>
            Save
          </span>
        </td>
      </tr>
    );
  },
  buildLinkForTitle() {
    const linkableTypes = ['trails', 'at_map_markers'];
    if (linkableTypes.includes(this.state.selectedTable) && this.state.originalSlug) {
      return `/trail/${this.state.originalSlug}`;
    }
    return null;
  },
  getRefContentLength(refId, currTranslationText) {
    if (!this.refs[refId]) {
      return currTranslationText?.length || 0;
    }
    return this.refs[refId].value.length;
  },
  showCharacterCount() {
    return ['name', 'description'].includes(this.state.selectedColumnName);
  },
  renderOriginalTextDisplay() {
    if (this.state.sourceEntry) {
      const link = this.buildLinkForTitle();
      const title = link ?
        (<a target="_blank" href={link}>{this.state.sourceEntry}</a>) :
        (<p>{this.state.sourceEntry}</p>)
      return (
        <div>
          <h3>Original Text</h3>
          {title}
        </div>
      );
    }
    return null;
  },
  renderTranslationTableRow(currTranslation, i) {
    const languageOptions = this.generateOptions();
    return (
      <tr key={currTranslation.language}>
        <td className={styles.languageSelectCell}>
          <select ref={`translation-langcode-${i}`} value={currTranslation.language} onChange={this.handleLanguageSelectChange.bind(this, i)}>
            {languageOptions}
          </select>
          {this.showCharacterCount() && (
            <h3 className={styles.contentCharacterCount}>{`(${this.getRefContentLength(
              `content-${currTranslation.language}`,
              currTranslation.content
            )})`}</h3>
          )}
        </td>
        <td>
          <input type="checkbox" checked={currTranslation.is_source} onChange={this.handleChangeSource.bind(this, i)} />
        </td>
        <td>{this.translatedByHash[currTranslation.translated_by]}</td>
        <td>
          <textarea
            id={`content-${currTranslation.language}`}
            ref={`content-${currTranslation.language}`}
            value={currTranslation.content ? currTranslation.content : ''}
            onChange={this.handleTextAreaKeyUp.bind(this, i)}
          />
        </td>
        <td>
          <span className="btn btn-slim blue rounded" onClick={this.handleRetranslateClick.bind(this, i, currTranslation.language)}>
            Retranslate
          </span>
          <span className="btn btn-slim orange rounded" onClick={this.handleDeleteClick.bind(this, i, currTranslation.language)}>
            Delete
          </span>
        </td>
      </tr>
    );
  },
  render() {
    return (
      <div className="edition-details">
        {this.renderOriginalTextDisplay()}
        <div className="trail-edit-form">
          {this.renderSearchSelections()}
          {this.renderButtonContainer()}
          {this.renderTableOrg(this.state.translations)}
        </div>
      </div>
    );
  }
});

export { TranslationEditInterface };
